/*
 * Description:
 * ---------------------
 * A list of addresses and networks typed one at a time, the way AWS's
 * security group editor takes a source: a search-style box, Enter (or a
 * comma, or leaving the box) adds what was typed as a chip under it, and each
 * chip has its own remove. What is not an address or network is said at once
 * rather than left for the box to refuse. Used by the firewall's rules and
 * device groups.
 *
 * ! file components/AddressChips.js
 */
import React, { useState } from "react";
import { FiPlus, FiSearch, FiX } from "react-icons/fi";
import * as W from "./firewallWords";

export default function AddressChips({ values, onChange, placeholder, label, disabled }) {
  const [text, setText] = useState("");
  const [bad, setBad] = useState("");
  const add = () => {
    const parts = text.split(/[\s,]+/).filter(Boolean);
    if (!parts.length) return;
    const wrong = parts.find((p) => !W.isPlace(p));
    if (wrong) {
      setBad(W.notAPlace(wrong));
      return;
    }
    onChange([...values, ...parts.filter((p, i) => !values.includes(p) && parts.indexOf(p) === i)]);
    setText("");
    setBad("");
  };
  return (
    <div className="fw-chips">
      <div className="fw-chips-box">
        <FiSearch size={14} aria-hidden="true" />
        <input value={text} disabled={disabled} placeholder={placeholder} aria-label={label} aria-invalid={!!bad}
          onChange={(e) => { setText(e.target.value); setBad(""); }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === ",") {
              e.preventDefault();
              add();
            }
          }}
          onBlur={add} />
        <button type="button" className="fw-chips-add" aria-label={`Add ${label}`} title="Add" disabled={disabled || !text.trim()} onClick={add}>
          <FiPlus size={14} />
        </button>
      </div>
      {bad && <p className="fw-field-bad">{bad}</p>}
      {values.length > 0 && (
        <ul className="fw-chip-list">
          {values.map((v) => (
            <li key={v}>
              <span>{W.shown(v)}</span>
              <button type="button" aria-label={`Remove ${W.shown(v)}`} disabled={disabled}
                onClick={() => onChange(values.filter((x) => x !== v))}><FiX size={13} /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
